export default __webpack_public_path__ + "static/media/profileimage.7c27321d.png";